/**
 * Shared custom sort orders for report columns such as Risk, Alert, Priority, etc.
 *
 * These arrays represent the ascending order for the configured column.
 * The sorting engine automatically reverses this when the user selects descending.
 */
export const REPORT_SORT_ORDERS: Record<string, readonly string[]> = {
   riskHighToLow: ['high', 'medium', 'low'],
   riskLowToHigh: ['low', 'medium', 'high'],
   alertHighToLow: ['high', 'medium', 'low'],
   alertLowToHigh: ['low', 'medium', 'high'],
   priorityHighToLow: ['high', 'medium', 'low'],
   priorityLowToHigh: ['low', 'medium', 'high']
};
